<script setup lang="ts">
import OrthoNeedsAddEditForm from "@/components/models/patient/forms/OrthoNeedsAddEditForm.vue";
import { useOrthoNeeds } from "@/composables/models/patient/useOrthoNeeds";
import { usePatient } from "@/composables/models/patient/usePatient";
import { definePage } from "unplugin-vue-router/runtime";
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useAbility } from "@casl/vue";
import { useI18n } from "vue-i18n";
import QuestionnaireLayout from "@/components/models/patient/questionnaire/QuestionnaireLayout.vue";
import QuestionnaireSideBar from "@/components/models/patient/questionnaire/QuestionnaireSideBar.vue";

definePage({
  meta: {
    title: "generic.action.editEntity",
    titleParams: { entity: "generic.entity.orthoNeedsPlan" },
    checkPrivileges: () => {
      const { can } = useAbility();
      return can($permActions.UPDATE, $permSubjects.PATIENT__ORTHONEEDSPATIENT);
    },
  },
});

const { t } = useI18n();
const route = useRoute();
const routeParams = route.params as { id: string };
const patientId = computed(() => orthoNeeds.value?.patient ?? "");

const { data: orthoNeeds, isLoading: isOrthoNeedsLoading } = useOrthoNeeds(
  { id: routeParams.id },
  { redirectOnNotFound: true }
);

const { data: patient, isLoading: isPatientLoading } = usePatient(
  {
    id: patientId,
  },
  { redirectOnNotFound: true }
);
</script>

<template>
  <v-skeleton-loader :loading="isOrthoNeedsLoading || isPatientLoading">
    <questionnaire-layout
      :title="t('models.patient.orthoNeeds.title')"
      show-compact-summary
    >
      <ortho-needs-add-edit-form
        v-if="patient"
        :patient="patient"
        :ortho-needs="orthoNeeds"
      />

      <template #sidebar>
        <questionnaire-side-bar :patient="patient" />
      </template>
    </questionnaire-layout>
  </v-skeleton-loader>
</template>

<style scoped></style>
